

/*---------START: Complementary Product Script----------*/ 

document.addEventListener('DOMContentLoaded', function() {
  const selectElements = document.querySelectorAll('.option-select_variant');
  let selectedValues = {};

  selectElements.forEach(function(selectElement) {
    selectedValues[selectElement.name] = selectElement.value;

    selectElement.addEventListener('change', function() {
      const selectedValue = selectElement.value;
      selectedValues[selectElement.name] = selectedValue;

      const formattedString = formatSelectedValues(selectedValues);
      filterComplementaryProducts(formattedString);
    });
  });

  function formatSelectedValues(values) {
    return Object.entries(values)
      .map(([key, value]) => value.replace(/ /g, '_').toLowerCase())
      .join('_/_');
  }

  function filterComplementaryProducts(formattedString) {
    const productItems = document.querySelectorAll('.complementary_product_item');
    let hasVisibleProducts = false;

    productItems.forEach(function(item) {
      if (item.getAttribute('data-variant').toLowerCase() === formattedString) {
        item.style.display = 'block';
        hasVisibleProducts = true;
      } else {
        item.style.display = 'none';
      }
    });

    const headingElement = document.querySelector('.accessories_complementary_product .heading');
    if (headingElement) {
      headingElement.style.display = hasVisibleProducts ? 'block' : 'none';
    }

    toggleParentSectionDisplay();
  }

  function toggleParentSectionDisplay() {
    const sections = document.querySelectorAll('.complementary_product_section');

    sections.forEach(function(section) {
      const items = section.querySelectorAll('.complementary_product_item');
      let hasVisibleItem = false;

      items.forEach(function(item) {
        if (item.style.display === 'block') {
          hasVisibleItem = true;
        }
      });

      section.style.display = hasVisibleItem ? 'block' : 'none';
    });
  }

  const initialFormattedString = formatSelectedValues(selectedValues);
  filterComplementaryProducts(initialFormattedString);

  document.querySelectorAll('.complementary_product_item').forEach(function(item) {
    item.addEventListener('click', function(event) {
      const checkbox = this.querySelector('.products_checkbox');
      if (checkbox) {
        if (checkbox.checked) {
          checkbox.checked = false;
          checkbox.removeAttribute('checked');
          this.classList.remove('highlight_border');
        } else {
          checkbox.checked = true;
          checkbox.setAttribute('checked', 'checked');
          this.classList.add('highlight_border');
        }
      }
    });
  });

  document.querySelectorAll('.products_checkbox').forEach(function(checkbox) {
    checkbox.addEventListener('click', function(event) {
      event.stopPropagation(); // Prevent the parent div click event
      if (this.checked) {
        this.setAttribute('checked', 'checked');
        this.closest('.complementary_product_item').classList.add('highlight_border');
      } else {
        this.removeAttribute('checked');
        this.closest('.complementary_product_item').classList.remove('highlight_border');
      }
    });
  });
});

/*----------END: Complementary Product Script----------*/




/*----------START: Cart Drawer present Product Script----------*/

function fetchCartData() {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      const products = data.items.map(item => ({
        title: item.title,
        url: item.url,
        quantity: item.quantity,
        id: item.id
      }));

      console.log('Products in cart:', products);
      
      const complementaryProducts = logComplementaryProducts(products);
      compareAndDisplayMatchingProducts(products, complementaryProducts);
    })
    .catch(error => {
      console.error('Error fetching cart data:', error);
    });
}

function logComplementaryProducts(products) {
  const complementaryProductSection = document.querySelector('.accessories_complementary_product');
  if (!complementaryProductSection) {
    return [];
  }

  const complementaryProducts = [];

  const complementaryProductItems = complementaryProductSection.querySelectorAll('.complementary_product_item');
  complementaryProductItems.forEach(item => {
    const productUrl = item.querySelector('.products_checkbox').dataset.url;
    const productId = item.querySelector('.products_checkbox').dataset.id;
    const inventoryQuantity = parseInt(item.querySelector('.products_checkbox').dataset.inventoryQuantity, 10);

    complementaryProducts.push({
      url: productUrl,
      id: productId,
      inventoryQuantity: inventoryQuantity
    });
  });
console.log('Complementary Products:', complementaryProducts);
  return complementaryProducts;
}

function compareAndDisplayMatchingProducts(products, complementaryProducts) {
  complementaryProducts.forEach(complementaryProduct => {
    const matchingProduct = products.find(product => product.id == complementaryProduct.id);
    if (matchingProduct) {
      
  console.log(`Matching Product - ID: ${matchingProduct.id}, Quantity: ${matchingProduct.quantity}, Inventory Quantity: ${complementaryProduct.inventoryQuantity}`);

            
      const newInventoryQuantity = complementaryProduct.inventoryQuantity - matchingProduct.quantity;

      console.log(`New Inventory Quantity for ID ${matchingProduct.id}: ${newInventoryQuantity}`);


      if (newInventoryQuantity < 1) {
        const inputElement = document.querySelector(`.products_checkbox[data-id='${matchingProduct.id}']`);
        if (inputElement) {
          const loadTrackInventory = inputElement.getAttribute('data-inventory_track_or_notContinue');
           if (loadTrackInventory !== null) {
                              
          inputElement.classList.add('low-inventory-product');
          inputElement.checked = false;
          inputElement.setAttribute('disabled', 'disabled');
          inputElement.removeAttribute('checked');

          const parentItem = inputElement.closest('.complementary_product_item');
          if (parentItem) {
            parentItem.classList.remove('highlight');
            parentItem.style.pointerEvents = 'none';
            console.log('global.js code run');
          }
           }
        }
      }
    }
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const selectElements = document.querySelectorAll('.option-select_variant');
  let selectedValues = {};

  selectElements.forEach(function(selectElement) {
    selectedValues[selectElement.name] = selectElement.value;

    selectElement.addEventListener('change', function() {
      const selectedValue = selectElement.value;
      selectedValues[selectElement.name] = selectedValue;

      const formattedString = formatSelectedValues(selectedValues);
      filterComplementaryProducts(formattedString);
    });
  });

  function formatSelectedValues(values) {
    return Object.entries(values)
      .map(([key, value]) => value.replace(/ /g, '_').toLowerCase())
      .join('_/_');
  }

  function filterComplementaryProducts(formattedString) {
    const productItems = document.querySelectorAll('.complementary_product_item');
    let hasVisibleProducts = false;

    productItems.forEach(function(item) {
      if (item.getAttribute('data-variant').toLowerCase() === formattedString) {
        item.style.display = 'block';
        hasVisibleProducts = true;
      } else {
        item.style.display = 'none';
      }
    });

    const headingElement = document.querySelector('.accessories_complementary_product .heading');
    if (headingElement) {
      headingElement.style.display = hasVisibleProducts ? 'block' : 'none';
    }
  }

  const initialFormattedString = formatSelectedValues(selectedValues);
  filterComplementaryProducts(initialFormattedString);

  document.querySelectorAll('.products_checkbox').forEach(function(checkbox) {
    checkbox.addEventListener('change', function() {
      const parentItem = this.closest('.complementary_product_item');
      if (this.checked) {
        this.setAttribute('checked', 'checked');
        parentItem.classList.add('highlight_border');
      } else {
        this.removeAttribute('checked');
        parentItem.classList.remove('highlight_border');
      }
    });
  });
});


fetchCartData();

/*----------END: Cart Drawer present Product Script----------*/